<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-large"
    title="確認"
  >
    <template v-slot:body="{ cancel }">
      <validation-observer v-slot="{ handleSubmit }" as="div">
        <v-form novalidate @submit.stop.prevent="handleSubmit(submit)">
          <v-card-text class="pa-4">
            <div class="modal-body">
              <div class="font-weight-bold mb-3">
                インターネットType1を変更します。よろしいですか？
              </div>
              <!-- インターネットType1 -->
              <v-row>
                <v-col>
                  <h3>インターネットType1</h3>
                </v-col>
              </v-row>
              <v-row class="px-4">
                <v-col cols="4">
                  <app-label-group
                    label="VPNコード"
                    :value="selectedItem.vpnCode"
                  ></app-label-group>
                </v-col>
                <v-col cols="4">
                  <app-label-group
                    label="回線番号(メイン)"
                    :value="`${selectedItem.enumberMainAct}/${selectedItem.enumberMainSby}`"
                  ></app-label-group>
                </v-col>
                <v-col cols="4">
                  <app-label-group
                    label="回線番号(BCP)"
                    :value="`${selectedItem.enumberBcpAct}/${selectedItem.enumberBcpSby}`"
                  ></app-label-group>
                </v-col>
              </v-row>
              <!-- アプライアンス -->
              <v-row>
                <v-col>
                  <h3>アプライアンス</h3>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4">
                  <app-label-group label="セキュリティアプライアンス">
                    <template #value>
                      <div class="ml-3">
                        <template v-if="selectedItem.applianceType === 'UTM'">
                          UTM(1Gbpsベストエフォート)
                        </template>
                        <template v-if="selectedItem.applianceType === 'IFW'">
                          インターネットFW(帯域確保型{{
                            $filter.bandwidthTo(putItem.bandwidth!)
                          }})
                        </template>
                      </div>
                    </template>
                  </app-label-group>
                </v-col>
                <template v-if="user.contractSummary.isSecuritySetting">
                  <v-col cols="4">
                    <app-label-group
                      label="セキュリティ監視オプション"
                      :value="
                        $filter.enumTo(selectedItem.isSecurityOption, 'on_off')
                      "
                    />
                  </v-col>
                </template>
                <v-col cols="4">
                  <app-label-group label="インターネット帯域">
                    <template #value>
                      <div class="ml-3">
                        <template v-if="selectedItem.applianceType === 'UTM'">
                          1Gbpsベストエフォート
                        </template>
                        <template v-if="selectedItem.applianceType === 'IFW'">
                          帯域確保型{{ putItem.bandwidth!.value }}Mbps
                        </template>
                      </div>
                    </template>
                  </app-label-group>
                </v-col>
              </v-row>
              <!-- オプション -->
              <v-row>
                <v-col>
                  <h3>オプション</h3>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4">
                  <app-label-group label="グローバルIP">
                    <template #value>
                      <div class="ml-3">
                        <span>
                          追加グローバルIP数
                          {{ putItem.numberOfAddGlobalIpAddress }} 個
                        </span>
                        <div
                          v-for="(item, index) in globalIpAddressList"
                          :key="index"
                        >
                          <span>{{ item.globalIpAddress }}</span>
                        </div>
                        <div
                          v-for="i in putItem.numberOfAddGlobalIpAddress"
                          :key="i"
                        >
                          <span>設定完了後にIPが払い出されます</span>
                        </div>
                      </div>
                    </template>
                  </app-label-group>
                </v-col>
                <v-col cols="4">
                  <app-label-group
                    label="状態"
                    :value="$filter.enumTo(selectedItem.status, 'status')"
                  />
                </v-col>
              </v-row>
              <!-- 備考 -->
              <v-row>
                <!-- prettier-ignore  -->
                <v-col>
                  <!-- eslint-disable-next-line vue/no-mutating-props -->
                  <validation-provider name="note" v-model="putItem.note"
                    label="オーダー備考"
                    :rules="{ max: { length: 200 } }"
                    v-slot="{ componentField, errorMessage, meta }"
                  >
                    <app-badge
                      item="オーダー備考"
                      :msg="
                        $filter.message('info_max_length', {
                          maxLength: '200',
                        })
                      "
                      :isRequired="false"
                      placement="end"
                    />
                    <app-form-input
                      v-bind="componentField"
                      :error-messages="errorMessage"
                      :field-meta="meta"
                    />
                  </validation-provider>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-list-item class="w-100 pa-1">
              <template v-slot:append>
                <v-btn type="submit" variant="flat" color="primary">はい</v-btn>
                <v-btn variant="outlined" color="primary" @click="cancel"
                  >いいえ
                </v-btn>
              </template>
            </v-list-item>
          </v-card-actions>
        </v-form>
      </validation-observer>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type {
  Type1Service,
  ContractChangeType1PutRequest,
  GlobalIpAddress,
} from "@/apis/ContractChangeType1Api";
import { VueFinalModal } from "vue-final-modal";
import AppLabelGroup from "@/components/AppLabelGroup.vue";

export default defineComponent({
  name: "InternetType1ContractConfirm",
  components: { AppLabelGroup },
  props: {
    selectedItem: {
      type: Object as PropType<Type1Service>,
      required: true,
    },
    putItem: {
      type: Object as PropType<ContractChangeType1PutRequest>,
      required: true,
    },
    globalIpAddressList: {
      type: Array as PropType<GlobalIpAddress[]>,
      required: true,
    },
  },
  data() {
    return {
      user: this.$store.state.user,
    };
  },
  methods: {
    /** 「はい」選択時の挙動 */
    submit() {
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
  },
});
</script>
